import React from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import SectionTitle from "./SectionTitle";
import { highlights, pillars } from "./homeData";

const cardStyles = {
  height: "100%",
  borderRadius: "18px",
  boxShadow: "0 16px 32px rgba(15, 23, 42, 0.1)",
  border: "1px solid rgba(148, 163, 184, 0.15)",
  transition: "all 0.3s ease",
  '&:hover': {
    transform: "translateY(-6px)",
    boxShadow: "0 24px 48px rgba(15, 23, 42, 0.18)",
  },
};

export default function HighlightsSection() {
  return (
    <Box component="section" py={10} bgcolor={(theme) => theme.palette.background.default}>
      <Container>
        <SectionTitle
          eyebrow="Value I bring"
          title="Product thinking with engineering precision"
          subtitle="From discovery to delivery, I partner with teams to design, prototype, and launch experiences that feel cohesive and thoughtful."
        />
        <Grid container spacing={4}>
          {highlights.map((item) => {
            const Icon = item.icon;
            return (
              <Grid item xs={12} md={4} key={item.title}>
                <Card sx={cardStyles}>
                  <CardContent>
                    <Stack spacing={2}>
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: "16px",
                          display: "grid",
                          placeItems: "center",
                          bgcolor: "rgba(99, 102, 241, 0.1)",
                          color: (theme) => theme.palette.primary.main,
                        }}
                      >
                        <Icon fontSize="large" />
                      </Box>
                      <Typography variant="h3" component="h3" sx={{ fontWeight: 600 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {item.description}
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
        <Grid container spacing={4} mt={{ xs: 4, md: 6 }}>
          {pillars.map((item) => {
            const Icon = item.icon;
            return (
              <Grid item xs={12} md={4} key={item.title}>
                <Card sx={{
                  ...cardStyles,
                  background: "linear-gradient(135deg, rgba(99,102,241,0.08), rgba(129,140,248,0.12))",
                  border: "none",
                }}>
                  <CardContent>
                    <Stack spacing={2}>
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: "16px",
                          display: "grid",
                          placeItems: "center",
                          bgcolor: "rgba(15, 23, 42, 0.08)",
                          color: "inherit",
                        }}
                      >
                        <Icon fontSize="large" />
                      </Box>
                      <Typography variant="h3" component="h3" sx={{ fontWeight: 600 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {item.description}
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
